// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.regen-dialog {
  min-width: 0;
  padding: 1rem;
}

.regen-dialog__header {
  margin-bottom: 1rem;
}

.regen-dialog__title {
  margin: 0 0 0.5rem;
  font-size: 1.35rem;
  font-weight: 700;
}

.regen-dialog__subtitle {
  margin: 0;
  color: #6c757d;
  line-height: 1.4;
}

.regen-dialog__body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.regen-dialog__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.regen-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.regen-field__label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
}

.regen-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.regen-radio-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.regen-dialog__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 0.25rem;
}

.regen-dialog__actions .btn-primary {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.regen-dialog__actions .btn-primary:hover:not(:disabled) {
  background-color: #0b5ed7;
  border-color: #0a58ca;
}

.regen-dialog__actions .btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
}

.regen-dialog__actions .btn-secondary:hover:not(:disabled) {
  background-color: #5c636a;
  border-color: #565e64;
}

@media (max-width: 640px) {
  .regen-dialog__grid {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/saturday-chart/weekly-report-regeneration-dialog/weekly-report-regeneration-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE;IACE,0BAAA;EACF;AACF;AACA,giGAAgiG","sourcesContent":[".regen-dialog {\n  min-width: 0;\n  padding: 1rem;\n}\n\n.regen-dialog__header {\n  margin-bottom: 1rem;\n}\n\n.regen-dialog__title {\n  margin: 0 0 0.5rem;\n  font-size: 1.35rem;\n  font-weight: 700;\n}\n\n.regen-dialog__subtitle {\n  margin: 0;\n  color: #6c757d;\n  line-height: 1.4;\n}\n\n.regen-dialog__body {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.regen-dialog__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.regen-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.regen-field__label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #495057;\n}\n\n.regen-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.regen-radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.regen-dialog__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 0.25rem;\n}\n\n.regen-dialog__actions .btn-primary {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n}\n\n.regen-dialog__actions .btn-primary:hover:not(:disabled) {\n  background-color: #0b5ed7;\n  border-color: #0a58ca;\n}\n\n.regen-dialog__actions .btn-secondary {\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.regen-dialog__actions .btn-secondary:hover:not(:disabled) {\n  background-color: #5c636a;\n  border-color: #565e64;\n}\n\n@media (max-width: 640px) {\n  .regen-dialog__grid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
